import { Controller } from "stimulus";

export default class extends Controller {

  frequencyChanged(event) {
    var frequency = $(event.target).val()
    if(frequency == 'weekly' || frequency == 'biweekly') {
      $('.js-billing-day-of-week').show();
      $('.js-billing-day-of-month').hide()
    } else if(frequency == 'monthly') {
      $('.js-billing-day-of-week').hide();
      $('.js-billing-day-of-month').show()
    } else {
      $('.js-billing-day-of-week').hide();
      $('.js-billing-day-of-month').hide()
    }
  }
}